import { render, staticRenderFns } from "./m-editTopicSNPMB.vue?vue&type=template&id=3ed5925b&"
import script from "./m-editTopicSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-editTopicSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports